const updateItemInArray = (array, index, item) => array.slice(0, index).concat([item]).concat(array.slice(index + 1));
export default updateItemInArray;